export const SAINTS_DATA = [
    {
        "name": "Agata",
        "code": "agata",
        "description": null,
        "anniversary": "05/02",
        "abbreviation": "Agata",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Alphongsô",
        "code": "alphongso",
        "description": null,
        "anniversary": "01/08",
        "abbreviation": "Alphongsô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Anatasia",
        "code": "anatasia",
        "description": null,
        "anniversary": null,
        "abbreviation": "Anatasia",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Anê",
        "code": "ane",
        "description": null,
        "anniversary": "21/01",
        "abbreviation": "Anê",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Anna",
        "code": "anna",
        "description": null,
        "anniversary": "26/07",
        "abbreviation": "Anna",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Anrê",
        "code": "anre",
        "description": null,
        "anniversary": "30/11",
        "abbreviation": "Anrê",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Antôn",
        "code": "anton",
        "description": null,
        "anniversary": "13/06",
        "abbreviation": "Antôn",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Augustinô",
        "code": "augustino",
        "description": null,
        "anniversary": "28/08",
        "abbreviation": "Augustinô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Basilio",
        "code": "basilio",
        "description": null,
        "anniversary": "02/01",
        "abbreviation": "Basilio",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Batôlômêô",
        "code": "batolomeo",
        "description": null,
        "anniversary": "24/08",
        "abbreviation": "Batôlômêô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Catarina",
        "code": "catarina",
        "description": null,
        "anniversary": "29/04",
        "abbreviation": "Catarina",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Cecilia",
        "code": "cecilia",
        "description": null,
        "anniversary": "22/11",
        "abbreviation": "Cecilia",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Clara",
        "code": "clara",
        "description": null,
        "anniversary": "11/08",
        "abbreviation": "Clara",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Claret",
        "code": "claret",
        "description": null,
        "anniversary": "24/10",
        "abbreviation": "Claret",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Ðaminh",
        "code": "daminh",
        "description": null,
        "anniversary": "08/08",
        "abbreviation": "Ðaminh",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Daminh Savio",
        "code": "daminh savio",
        "description": null,
        "anniversary": "06/05",
        "abbreviation": "Daminh Savio",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Emmanuel",
        "code": "emmanuel",
        "description": null,
        "anniversary": null,
        "abbreviation": "Emmanuel",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Giacôbê",
        "code": "giacobe",
        "description": null,
        "anniversary": "25/07",
        "abbreviation": "Giacôbê",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Giêrađô",
        "code": "gierado",
        "description": null,
        "anniversary": "16/10",
        "abbreviation": "Giêrađô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Giêrônimô",
        "code": "gieronimo",
        "description": "",
        "anniversary": "30/09",
        "abbreviation": "Giêrônimô",
        "subtitle": "",
        "status": "active"
    },
    {
        "name": "Gioakim",
        "code": "gioakim",
        "description": null,
        "anniversary": "26/07",
        "abbreviation": "Gioakim",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Gioan",
        "code": "gioan",
        "description": null,
        "anniversary": "27/12",
        "abbreviation": "Gioan",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Gioan Baotixita",
        "code": "gioan baotixita",
        "description": null,
        "anniversary": "20/06",
        "abbreviation": "Gioan Baotixita",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Giuse",
        "code": "giuse",
        "description": null,
        "anniversary": "19/03",
        "abbreviation": "Giuse",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Gregorio",
        "code": "gregorio",
        "description": null,
        "anniversary": "03/09",
        "abbreviation": "Gregorio",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Henricô",
        "code": "henrico",
        "description": null,
        "anniversary": "13/07",
        "abbreviation": "Henricô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Inê",
        "code": "ine",
        "description": null,
        "anniversary": "21/01",
        "abbreviation": "Inê",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Inhaxio",
        "code": "inhaxio",
        "description": null,
        "anniversary": "17/10",
        "abbreviation": "Inhaxio",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Isave",
        "code": "isave",
        "description": null,
        "anniversary": "26/07",
        "abbreviation": "Isave",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Katarina",
        "code": "katarina",
        "description": null,
        "anniversary": "29/04",
        "abbreviation": "Katarina",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Laurensô",
        "code": "laurenso",
        "description": null,
        "anniversary": "10/08",
        "abbreviation": "Laurensô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Lôrensô",
        "code": "lorenso",
        "description": null,
        "anniversary": "10/08",
        "abbreviation": "Lôrensô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Luca",
        "code": "luca",
        "description": null,
        "anniversary": "18/10",
        "abbreviation": "Luca",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Lucia",
        "code": "lucia",
        "description": null,
        "anniversary": "13/12",
        "abbreviation": "Lucia",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Mácta",
        "code": "macta",
        "description": null,
        "anniversary": "29/07",
        "abbreviation": "Mácta",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Maria",
        "code": "maria",
        "description": null,
        "anniversary": "12/09",
        "abbreviation": "Maria",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Maria Goretti",
        "code": "maria goretti",
        "description": null,
        "anniversary": "06/07",
        "abbreviation": "Maria Goretti",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Maria Madalena",
        "code": "maria madalena",
        "description": null,
        "anniversary": "22/07",
        "abbreviation": "Maria Madalena",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Martinô",
        "code": "martino",
        "description": null,
        "anniversary": "03/11",
        "abbreviation": "Martinô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Mary",
        "code": "mary",
        "description": null,
        "anniversary": "18/04",
        "abbreviation": "Mary",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Matthêu",
        "code": "mattheu",
        "description": null,
        "anniversary": "21/09",
        "abbreviation": "Matthêu",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Micae",
        "code": "micae",
        "description": null,
        "anniversary": "29/09",
        "abbreviation": "Micae",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Nicôla",
        "code": "nicola",
        "description": null,
        "anniversary": "06/12",
        "abbreviation": "Nicôla",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Phanxicô",
        "code": "phanxico",
        "description": null,
        "anniversary": "02/04",
        "abbreviation": "Phanxicô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Phanxicô Xaviê",
        "code": "phanxico xavie",
        "description": null,
        "anniversary": "03/12",
        "abbreviation": "Phanxicô Xaviê",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Phaolô",
        "code": "phaolo",
        "description": null,
        "anniversary": "29/06",
        "abbreviation": "Phaolô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Phêrô",
        "code": "phero",
        "description": null,
        "anniversary": "29/06",
        "abbreviation": "Phêrô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Philipphê",
        "code": "philipphe",
        "description": null,
        "anniversary": "03/05",
        "abbreviation": "Philipphê",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Rosa",
        "code": "rosa",
        "description": null,
        "anniversary": "23/08",
        "abbreviation": "Rosa",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Simon",
        "code": "simon",
        "description": null,
        "anniversary": "28/10",
        "abbreviation": "Simon",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Stêphanô",
        "code": "stephano",
        "description": null,
        "anniversary": "26/12",
        "abbreviation": "Stêphanô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Têphanô",
        "code": "tephano",
        "description": null,
        "anniversary": "16/08",
        "abbreviation": "Têphanô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Têrêsa",
        "code": "teresa",
        "description": null,
        "anniversary": "01/10",
        "abbreviation": "Têrêsa",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Thánh Anrê NGUYỄN KIM THÔNG (Năm Thuông)",
        "code": "thanh-anre-nguyen-kim-thong-nam-thuong",
        "description": "Thánh Anrê Nguyễn Kim Thông sinh năm 1790, tại họ Gò Thị, xã Xuân Phương, huyện Tuy Phước, tỉnh Bình Định, Giáo phận Qui Nhơn ngày nay. Ngài là người con thứ tư trong gia đình, nhưng theo tục lệ địa phương thì gọi là thứ năm, và được gọi cách kính trọng là Ông Năm Thuông. Ông có hai người con sống đời tận hiến là linh mục Nguyễn Kim Thủ và nữ tu Anna Nguyễn Thị Nhường, dòng Mến Thánh Giá Gò Thị...",
        "anniversary": "15/07",
        "abbreviation": "Anrê Thông",
        "subtitle": "Trùm cả (1790 - 1855)",
        "status": "active"
    },
    {
        "name": "Titô",
        "code": "tito",
        "description": "",
        "anniversary": "26/01",
        "abbreviation": "Titô",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Tôma",
        "code": "toma",
        "description": null,
        "anniversary": "03/07",
        "abbreviation": "Tôma",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Vincentê",
        "code": "vincente",
        "description": null,
        "anniversary": "22/01",
        "abbreviation": "Vincentê",
        "subtitle": null,
        "status": "active"
    },
    {
        "name": "Vinhsơn",
        "code": "vinhson",
        "description": null,
        "anniversary": "22/01",
        "abbreviation": "Vinhsơn",
        "subtitle": null,
        "status": "active"
    }
];

export const DIOCESES_DATA = [
    {
        name: 'Phú Cường',
        code: '',
        deActive: 0,
        order: 1
    },
    {
        name: 'Hà Nội',
        code: '',
        deActive: 0,
        order: 2
    },
    {
        name: 'Bắc Ninh',
        code: '',
        deActive: 0,
        order: 3
    },
    {
        name: 'Bùi Chu',
        code: '',
        deActive: 0,
        order: 4
    },
    {
        name: 'Hà Tĩnh',
        code: '',
        deActive: 0,
        order: 5
    },
    {
        name: 'Hải Phòng',
        code: '',
        deActive: 0,
        order: 6
    },
    {
        name: 'Hưng Hóa',
        code: '',
        deActive: 0,
        order: 7
    },
    {
        name: 'Lạng Sơn và Cao Bằng',
        code: '',
        deActive: 0,
        order: 8
    },
    {
        name: 'Phát Diệm',
        code: '',
        deActive: 0,
        order: 9
    },
    {
        name: 'Thái Bình',
        code: '',
        deActive: 0,
        order: 10
    },
    {
        name: 'Thanh Hóa',
        code: '',
        deActive: 0,
        order: 11
    },
    {
        name: 'Vinh',
        code: '',
        deActive: 0,
        order: 12
    },
    {
        name: 'Huế',
        code: '',
        deActive: 0,
        order: 13
    },
    {
        name: 'Ban Mê Thuột',
        code: '',
        deActive: 0,
        order: 14
    },
    {
        name: 'Đà Nẵng',
        code: '',
        deActive: 0,
        order: 15
    },
    {
        name: 'Kon Tum',
        code: '',
        deActive: 0,
        order: 16
    },
    {
        name: 'Nha Trang',
        code: '',
        deActive: 0,
        order: 17
    },
    {
        name: 'Qui Nhơn',
        code: '',
        deActive: 0,
        order: 18
    },
    {
        name: 'Sài Gòn(TP.HCM)',
        code: '',
        deActive: 0,
        order: 19
    },
    {
        name: 'Bà Rịa',
        code: '',
        deActive: 0,
        order: 20
    },
    {
        name: 'Cần Thơ',
        code: '',
        deActive: 0,
        order: 21
    },
    {
        name: 'Đà Lạt',
        code: '',
        deActive: 0,
        order: 22
    },
    {
        name: 'Long Xuyên',
        code: '',
        deActive: 0,
        order: 23
    },
    {
        name: 'Mỹ Tho',
        code: '',
        deActive: 0,
        order: 24
    },
    {
        name: 'Phan Thiết',
        code: '',
        deActive: 0,
        order: 25
    },
    {
        name: 'Vĩnh Long',
        code: '',
        deActive: 0,
        order: 26
    },
    {
        name: 'Xuân Lộc',
        code: '',
        deActive: 0,
        order: 27
    }
];

export const ANNIVERSARIES = [
    {
        name: "Bổn Mạng",
        type: "saint",
        hasAuto: true,
        includes: ['clergy', 'giao_xu', 'giao_diem', 'giao_ho', 'dong_tu', 'cong_doan', 'co_so_giao_phan', 'co_so_ngoai_giao_phan', 'giao_hat'],
        typeClergy: "all",
        typeOrg: "all",
    },
    {
        name: "Ngày Sinh",
        type: "birth",
        hasAuto: true,
        includes: ['clergy'],
        typeClergy: "all",
        typeOrg: "",
    },
    {
        name: "Ngày Thành Lập",
        type: "createdDate",
        hasAuto: true,
        includes: ['giao_xu', 'giao_diem', 'giao_ho', 'dong_tu', 'cong_doan', 'co_so_giao_phan', 'co_so_ngoai_giao_phan', 'giao_hat'],
        typeClergy: "",
        typeOrg: "all",
    },
    {
        name: "Rửa Tội",
        type: "baptize",
        hasAuto: true,
        includes: ['clergy'],
        typeClergy: "all",
        typeOrg: "",
    },
    {
        name: "Thêm Sức",
        type: "confirmation",
        hasAuto: true,
        includes: ['clergy'],
        typeClergy: "all",
        typeOrg: "",
    },
    {
        name: "Tiểu Chủng Viện",
        type: "smallSeminary",
        hasAuto: true,
        includes: ['clergy'],
        typeClergy: "tu_trieu",
        typeOrg: "",
    },
    {
        name: "Đại Chủng Viện",
        type: "bigSeminary",
        hasAuto: true,
        includes: ['clergy'],
        typeClergy: "tu_trieu",
        typeOrg: "",
    },
    {
        name: "Ngày Khấn",
        type: "vow",
        hasAuto: true,
        includes: ['clergy'],
        typeClergy: "tu_dong",
        typeOrg: "",
    },
    {
        name: "Kỷ Niệm",
        type: "anniversary",
        hasAuto: false,
        includes: ['clergy', 'giao_xu', 'giao_diem', 'giao_ho', 'dong_tu', 'cong_doan', 'co_so_giao_phan', 'co_so_ngoai_giao_phan', 'giao_hat'],
        typeClergy: "all",
        typeOrg: "",
    },
    {
        name: "Ngày Mất",
        type: "rip",
        hasAuto: false,
        includes: ['clergy'],
        typeClergy: "all",
        typeOrg: "",
    },
    {
        name: "Thụ Phong Phó Tế",
        type: "pho_te",
        hasAuto: false,
        includes: ['clergy'],
        typeClergy: "all",
        typeOrg: "",
    },
    {
        name: "Thụ Phong Linh Mục",
        type: "linh_muc",
        hasAuto: false,
        includes: ['clergy'],
        typeClergy: "all",
        typeOrg: "",
    },
    // {
    //     name: "Ngày Mất",
    //     entityID: "",
    //     entityType: "",
    //     date: "",
    //     day: "",
    //     description: "",
    //     type: "rip",
    //     content: "",
    //     locationID: "",
    //     locationType: "",
    //     status: "active"
    // }
]

export const LEVEL_CLERGY = [
    {
        name: 'Giám Mục',
        code: 'giam_muc'
    },
    {
        name: 'Linh Mục',
        code: 'linh_muc'
    },
    {
        name: 'Phó Tế',
        code: 'pho_te'
    },
    {
        name: 'Thầy',
        code: 'thay'
    },
    {
        name: 'Tu Sĩ',
        code: 'tu_si'
    },
    {
        name: 'Khác',
        code: 'khac'
    }
]

export const LEVEL_CLERGY_MAP = {
    giam_muc: 'Giám Mục',
    linh_muc: 'Linh Mục',
    pho_te: 'Phó Tế',
    thay: 'Thầy',
    tu_si: 'Tu Sĩ',
    khac: 'Khác',
}

export const CLERGY_STATUS = [
    {
        name: 'Đang Phục Vụ',
        code: 'dang_phuc_vu'
    },
    {
        name: 'Du Học',
        code: 'du_hoc'
    },
    {
        name: 'Hưu',
        code: 'huu_duong'
    },
    {
        name: 'Mất',
        code: 'rip'
    },
    {
        name: 'Hồi Tục',
        code: 'hoi_tuc'
    },
    {
        name: 'Chữa Bệnh',
        code: 'chua_benh'
    },
    {
        name: 'Khác',
        code: 'khac'
    }
]

export const STATUS_CLERGY = [
    {
        name: 'Đương Nhiệm',
        code: 'duong_nhiem'
    },
    {
        name: 'Mãn Nhiệm',
        code: 'man_nhiem'
    },
    {
        name: 'Chờ Xác Nhận',
        code: 'cho_xac_nhan'
    },
    {
        name: 'Chờ Thuyên Chuyển',
        code: 'cho_thuyen_chuyen'
    }
]

export const LEVEL_POSITION = [
    {
        name: 'Giáo Phận',
        code: 'giao_phan'
    },
    {
        name: 'Giáo Hạt',
        code: 'giao_hat'
    },
    {
        name: 'Giáo Xứ',
        code: 'giao_xu'
    },
    {
        name: 'Dòng Tu',
        code: 'dong_tu'
    },
    {
        name: 'Cộng Đoàn',
        code: 'cong_doan'
    },
    {
        name: 'Khác',
        code: 'khac'
    }
]

export const LTYPE_ORG = [
    {
        name: 'Giáo Hạt',
        code: 'giao_hat',
        group: 'group'
    },
    {
        name: 'Giáo Xứ',
        code: 'giao_xu',
        group: 'organization'
    },
    {
        name: 'Giáo Điểm',
        code: 'giao_diem',
        group: 'organization'
    },
    {
        name: 'Giáo Họ',
        code: 'giao_ho',
        group: 'organization'
    },
    {
        name: 'Dòng Tu',
        code: 'dong_tu',
        group: 'group'
    },
    {
        name: 'Cộng Đoàn',
        code: 'cong_doan',
        group: 'group'
    },
    {
        name: 'Cơ Sở Giáo Phận',
        code: 'co_so_giao_phan',
        group: 'group'
    },
    {
        name: 'Cơ Sở Giáo Phận',
        code: 'co_so_ngoai_giao_phan',
        group: 'group'
    },
    {
        name: 'Ban Mục Vụ',
        code: 'ban_muc_vu',
        group: 'group'
    },
    {
        name: 'Ban Chuyên Môn',
        code: 'ban_chuyen_mon',
        group: 'group'
    }
]

const parableDaily = {
    name: "",
    code: "",
    quotation: "",
    parableID: "",
    date: ""
}

const scheduleEvents = {
    name: "",
    code: "",
    quotation: "",
    startDate: "",
    endDate: "",
    entityID: "",
    entityType: ""
}
export const POSITIONS = [
    {
        name: 'Chánh xứ',
        label: 'Chánh xứ',
        value: 'chanh_xu',
        code: 'chanh_xu'
    },
    {
        name: 'Phó Xứ',
        label: 'Phó Xứ',
        value: 'pho_xu',
        code: 'pho_xu'
    },
    {
        name: 'Phó Biệt Cư',
        label: 'Phó Biệt Cư',
        value: 'pho_biet_cu',
        code: 'pho_biet_cu'
    },
    {
        name: 'Quản xứ',
        label: 'Quản xứ',
        value: 'quan_xu',
        code: 'quan_xu'
    },
    {
        name: 'Quản hạt',
        label: 'Quản hạt',
        value: 'quan_hat',
        code: 'quan_hat'
    },
    {
        name: 'Giúp xứ',
        label: 'Giúp xứ',
        value: 'giúp_xu',
        code: 'giúp_xu'
    },
    {
        name: 'Hưu',
        label: 'Hưu',
        value: 'huu',
        code: 'huu'
    },
    {
        name: 'Phó Ban',
        label: 'Phó Ban',
        value: 'pho_ban',
        code: 'pho_ban'
    },
    {
        name: 'Khác',
        label: 'Khác',
        value: 'khac',
        code: 'khac'
    }
]
export const TYPE_ORG = [
    {
        name: 'Giáo Xứ',
        code: 'giao_xu'
    },
    {
        name: 'Giáo Họ',
        code: 'giao_ho'
    },
    {
        name: 'Giáo Điểm',
        code: 'giao_diem'
    },
    {
        name: 'Cơ Sở Giáo Phận',
        code: 'co_so_giao_phan'
    },
    {
        name: 'Cơ Sở Giáo Phận',
        code: 'co_so_ngoai_giao_phan'
    },
    {
        name: 'Dòng Tu',
        code: 'dong_tu'
    },
    {
        name: 'Cộng Đoàn',
        code: 'cong_doan'
    },
    {
        name: 'Khác',
        code: 'khac'
    }
]

export const MASSES_SCHEDULE = {
    SAT_AFTERNOON: {
        name: 'Chiều Thứ 7',
        code: 'chieu_thu_bay'
    },
    SUN: {
        name: 'Chúa Nhật',
        code: 'chua_nhat'
    },
    NORMAL_DAY: {
        name: 'Ngày Thường',
        code: 'ngay_thuong'
    }
}
